const CheckoutView = () =>
  import(
    /*webpackChunkName: "CheckoutView"*/ "../../../views/sales/CheckoutView.vue"
  );
export const checkout = {
  path: "checkout",
  name: "checkout-clean",
  component: CheckoutView,
  meta: {
    requiresAuth: true,
    requiresEntitlement: false,
  },
  props: (route: { params: { cycle: any; plan: any } }) => ({
    cycle: "monthly",
    plan: "basic",
  }),
};

export const checkoutCyclePlan = {
  path: "checkout/:cycle/:plan",
  name: "checkout",
  component: CheckoutView,
  meta: {
    requiresAuth: true,
    requiresEntitlement: false,
  },
  props: (route: { params: { cycle: any; plan: any } }) => ({
    cycle: route.params.cycle ?? "monthly",
    plan: route.params.plan ?? "basic",
  }),
};
